export enum ChangePasswordResponseStatus {
  Success = 'Success',
  InvalidPassword = 'InvalidPassword',
  SamePassword = 'SamePassword',
}
